/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function StreemApiArtifactLayoutEstimationFromJSON(json) {
    return StreemApiArtifactLayoutEstimationFromJSONTyped(json, false);
}
export function StreemApiArtifactLayoutEstimationFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'meshSid': !exists(json, 'mesh_sid') ? undefined : json['mesh_sid'],
        'storageUrl': !exists(json, 'storage_url') ? undefined : json['storage_url'],
        'status': !exists(json, 'status') ? undefined : json['status'],
        'startedAt': !exists(json, 'started_at') ? undefined : (new Date(json['started_at'])),
        'erroredAt': !exists(json, 'errored_at') ? undefined : (new Date(json['errored_at'])),
        'fulfilledAt': !exists(json, 'fulfilled_at') ? undefined : (new Date(json['fulfilled_at'])),
        'url': !exists(json, 'url') ? undefined : json['url'],
        'capturedAt': !exists(json, 'captured_at') ? undefined : (new Date(json['captured_at'])),
        'deletedAt': !exists(json, 'deleted_at') ? undefined : (new Date(json['deleted_at'])),
    };
}
export function StreemApiArtifactLayoutEstimationToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'mesh_sid': value.meshSid,
        'storage_url': value.storageUrl,
        'status': value.status,
        'started_at': value.startedAt === undefined ? undefined : (value.startedAt.toISOString()),
        'errored_at': value.erroredAt === undefined ? undefined : (value.erroredAt.toISOString()),
        'fulfilled_at': value.fulfilledAt === undefined ? undefined : (value.fulfilledAt.toISOString()),
        'url': value.url,
        'captured_at': value.capturedAt === undefined ? undefined : (value.capturedAt.toISOString()),
        'deleted_at': value.deletedAt === undefined ? undefined : (value.deletedAt.toISOString()),
    };
}
/**
* @export
* @enum {string}
*/
export var StreemApiArtifactLayoutEstimationStatus;
(function (StreemApiArtifactLayoutEstimationStatus) {
    StreemApiArtifactLayoutEstimationStatus["CAPTURED"] = "STATUS_CAPTURED";
    StreemApiArtifactLayoutEstimationStatus["ERROR"] = "STATUS_ERROR";
    StreemApiArtifactLayoutEstimationStatus["FULFILLED"] = "STATUS_FULFILLED";
    StreemApiArtifactLayoutEstimationStatus["REJECTED"] = "STATUS_REJECTED";
    StreemApiArtifactLayoutEstimationStatus["STARTED"] = "STATUS_STARTED";
    StreemApiArtifactLayoutEstimationStatus["UNKNOWN"] = "STATUS_UNKNOWN";
})(StreemApiArtifactLayoutEstimationStatus || (StreemApiArtifactLayoutEstimationStatus = {}));
//# sourceMappingURL=StreemApiArtifactLayoutEstimation.js.map